module.exports = __webpack_public_path__ + "img/t1.56a574ec.png";